import React, { useRef } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useInView } from "framer-motion"

import BlogHeroMedia from "../BlogHeroMedia"
import { TranslationIcon } from "../Icons"

import "./heroMedia.css"

const HeroMedia = ({ isDark, translation, link, title, singleImage, multipleLogos, bgPosition }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const imageExtensions = /\.(jpg|jpeg|png|svg)$/i;

    const commonContent = (
        <div ref={ref} className="container-custom">
            <div className="relative z-2 text-center inner-content">
                <div>
                    <h1 style={{
                        transform: isInView ? "none" : "translateX(-200px)",
                        opacity: isInView ? 1 : 0,
                        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                    }} className={`${isDark ? 'text--dark ':'text-white '}${translation !== null ? ' translation-heading':''}`}>{title}</h1>
                    {translation !== null && (
                        <div style={{
                            transform: isInView ? "none" : "translateX(2000px)",
                            opacity: isInView ? 1 : 0,
                            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s"
                        }} className="flex wrap justify-center translation">
                            <TranslationIcon />
                            {translation.map((item, index)=>(
                                <div key={index} className="item">
                                    <a href={`/page${encodeURI(item.buttonLink)}`}>{item.buttonName}</a>
                                </div>
                            ))}
                        </div>
                    )}
                    {singleImage !== null && (
                        <>{singleImage.mediaVisibility && (
                            <div className={(singleImage.mediaPosition === null || singleImage.mediaPosition === 'Default: Top') ? 'single-image--top':'single-image--bottom'}>
                                <img src={singleImage.media.gatsbyImageData.images.fallback.src} alt={singleImage.mediaName || 'Single Media'} />
                            </div>
                        )}</>
                    )}
                </div>
                <div className="absolute flex align-center justify-center multiple-logos">
                    {multipleLogos.map((item, index) => (
                        <div 
                            key={index} 
                            className="flex align-center" 
                            style={{
                                opacity: isInView ? 1 : 0,
                                transition: `all ${.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.9 * index}s`,
                                marginRight: '30px'
                            }}
                        >
                            <GatsbyImage
                                image={getImage(item)}
                                alt={title || `Logo ${index}`}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

    const content = imageExtensions.test(link) ? (
        commonContent
    ) : (
        <BlogHeroMedia data={{ heroMediaLink: link }} template="global">
            {commonContent}
        </BlogHeroMedia>
    );

    return (
        <div className="relative hero-media hero-media-img" style={{ backgroundImage: `url(${link})`, backgroundSize: 'cover', backgroundPosition: bgPosition !== 'Default' ? bgPosition : 'center center' }}>
            {content}
        </div>
    );
};

export default HeroMedia;